<template>
    <div>
        <el-row class="bottom20">
            <el-table :data="page.records" :row-class-name="getVisitedRowClassName" :cell-class-name="getSelectedCellClassName">
                <el-table-column prop="customerName">
                    <template slot="header" slot-scope="scope">
                        客户名称<br>
                        <!--<el-input size="mini" v-model="pageSearch.search.like_customerName" placeholder="客户名称">
                        </el-input>-->
                        <customer-select v-model="pageSearch.search.customerId"
                                         @change="pageSearch.search.contractId = null" :filterable="true" :clearable="true"
                                         size="mini">
                        </customer-select>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.customerName}}
                    </template>
                </el-table-column>

                <el-table-column prop="contractName">
                    <template slot="header" slot-scope="scope">
                        合同名称<br>
                        <!--<el-input size="mini" v-model="pageSearch.search.like_contractName" placeholder="合同名称">
                        </el-input>-->
                        <contract-select v-model="pageSearch.search.contractId"
                                         :customer-id="pageSearch.search.customerId" :filterable="true" :clearable="true"
                                         size="mini">
                        </contract-select>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.contractName}}
                    </template>
                </el-table-column>

                <el-table-column prop="month">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">调整月份</span><br>
                        <el-date-picker v-model="pageSearch.search.range_month" value-format="yyyy-MM" :unlink-panels="true"
                                        range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份"
                                        type="monthrange" size="mini" placeholder="调整月份">
                        </el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.month}}
                    </template>
                </el-table-column>

                <el-table-column prop="month">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">调整金额（元）</span><br>
                        <div style="height: 40px;"></div>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.amount}}
                    </template>
                </el-table-column>

                <el-table-column prop="realName">
                    <template slot="header" slot-scope="scope">
                        调整人员<br>
                        <div style="height: 40px;"></div>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.realName}}
                    </template>
                </el-table-column>

                <el-table-column>
                    <template slot="header" slot-scope="scope">
                        操作<br>
                        <div style="height: 40px;"></div>
                    </template>
                    <template slot-scope="scope">
                        <div>
                            <el-button @click="toShow(scope.row)" plain size="minimum">查看</el-button>
                            <el-button @click="toEdit(scope.row)" v-if="deleteBtnExisted" type="warning" plain size="minimum" >修改</el-button>
                            <el-button @click="toDelete(scope.row)" v-if="deleteBtnExisted" type="danger" plain size="minimum" >删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
            <el-pagination
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    :current-page="pageSearch.current"
                    :page-sizes="[10, 25, 50, 100]"
                    :page-size="pageSearch.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="page.total">
            </el-pagination>
        </el-row>
    </div>
</template>

<script>
    import _ from 'lodash'
    import Emitter from 'element-ui/src/mixins/emitter'
    import {AuthInfo} from '@/util/user/authInfo'
    import BillingServer from '@/api/billing'
    import PersonServer from '@/api/person'
    import {
        COMPONENT_MAIN, COMPONENT_LIST, FN_LIST_QUERY, PERMISSION_DELETE, PERMISSION_EDIT
    } from './contract.bill.adjust.common'

    import CustomerSelect from '@/views/billing/customer/component/customer.select'
    import ContractSelect from '@/views/billing/contract/component/contract.select'

    export default {
        name: COMPONENT_LIST,
        componentName: COMPONENT_LIST,
        mixins: [Emitter],
        inject: ['toDetailShow', 'toDetailAdd', 'toDetailEdit', 'toDetailRemove'],
        components: {CustomerSelect, ContractSelect},
        data() {
            return {
                key: 'id',
                currentRowData: null,
                visited: [],
                pageSearch: {
                    current: 1,
                    size: 10,
                    search: {
                        like_customerName: null,
                        like_contractName: null,
                        customerId: null,
                        contractId: null,
                        range_month: null,
                        userId: AuthInfo.userId,
                    },
                },
                page: {
                    total: 0,
                    records: []
                },
            };
        },
        computed: {
            editBtnExisted() {
                return (PERMISSION_EDIT == null || this.hasPermission(PERMISSION_EDIT));
            },
            deleteBtnExisted() {
                return (PERMISSION_DELETE == null || this.hasPermission(PERMISSION_DELETE));
            },
        },
        watch: {
            'pageSearch.current': {
                deep: false,
                handler() {
                    this.queryByPage();
                },
            },
            'pageSearch.size': {
                deep: false,
                handler() {
                    this.reQueryByPage();
                },
            },
            'page': {
                deep: true,
                handler(value) {
                    if (value.total > 0) {
                        let record;
                        let records = value.records;
                        if (this.currentRowData != null && this.currentRowData[this.key] != null) {
                            for (let i = 0, l = records.length; i < l; i++) {
                                if (this.currentRowData[this.key] === records[i][this.key]) {
                                    record = records[i];
                                    break;
                                }
                            }
                        }
                        if (record == null) {
                            record = records[0];
                        }
                        this.select(record);
                    }
                },
            },
            'pageSearch.search': {
                deep: true,
                handler(value) {
                    this.reQueryByPage();
                    if (value != null) {
                        this.dispatch(COMPONENT_MAIN, FN_LIST_QUERY);
                    }
                }
            }
        },
        methods: {
            handleCurrentChange(current) {
                this.pageSearch.current = current;
            },
            handleSizeChange(size) {
                this.pageSearch.size = size;
            },
            reQueryByPage() {
                if (this.pageSearch.current === 1) {
                    this.queryByPage();
                } else {
                    this.pageSearch.current = 1;
                }
            },
            async doQueryByPage() {
                let res, total = 0, records = [];
                res = await PersonServer.personApi.list({}, {loading: true});
                let persons = [], personMap = {};
                if (this.isSuccess(res)) {
                    persons = res.data.data;
                    personMap = _.keyBy(persons, 'personuid');
                }
                res = await BillingServer.contractBillAdjust.page(this.pageSearch, {loading: true});
                if (this.isSuccess(res)) {
                    records = res.data.data.records;
                    total = res.data.data.total;
                    records.forEach(record => {
                        let userId = record.userId;
                        let person = personMap[userId];
                        record.realName = person == null ? userId : person.realname;
                    });
                }
                this.page = {
                    total: total,
                    records: records,
                };
            },
            queryByPage: _.debounce(function() {
                this.doQueryByPage();
            }, 200) ,
            query() {
                this.queryByPage();
            },
            reQuery() {
                this.reQueryByPage();
            },
            select(data) {
                this.currentRowData = data;
            },
            getSelectedCellClassName({row}) {
                let cellClassName = '';
                if (this.currentRowData && this.currentRowData[this.key] === row[this.key]) {
                    cellClassName += ' currentAccess ';
                }
                return cellClassName;
            },
            visit(data) {
                let id = data[this.key];
                if (this.visited.indexOf(id) === -1) {
                    this.visited.push(id);
                }
            },
            getVisitedRowClassName({row}) {
                let rowClassName = '';
                if (this.visited.indexOf(row[this.key]) !== -1) {
                    rowClassName += ' visited';
                }
                return rowClassName;
            },
            toShow(data) {
                this.toDetailShow(data);
            },
            toEdit(data) {
                this.toDetailEdit(data);
            },
            toDelete(data) {
                this.toDetailRemove(data);
            },
            isSuccess(res) {
                return String(res.data.code) === '200' || String(res.data.code).toUpperCase() === 'OK' || res.data.success;
            }
        },
        mounted() {
        },
    }
</script>

<style scoped>

</style>